import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NetworkConstants, removeUndefined, SiteReferralItem } from 'diwimamodelweb/lib';
import { SiteReferralSettingForm } from '../model/form';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { SettingsService } from '../settings.service';


const checkURLValid = async (control: AbstractControl): Promise<ValidationErrors | null> => {
  const nregexp = new RegExp("(?=^\\S*$)(^(https:\\/\\/|http:\\/\\/)([A-Za-z0-9].*\\.[a-z].*)\\/$)", "gm")
  const forbidden = !nregexp.test(control.value as string)
  return forbidden ? {urlVlaid: {value: control.value}} : null;
};

@Component({
  selector: 'app-setting-site-referral',
  templateUrl: './setting-site-referral.component.html',
  styleUrls: ['./setting-site-referral.component.css', '../../app.component.scss']
})
export class SettingSiteReferralComponent implements OnInit {

  @Input() data: SiteReferralSettingForm //BaseSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService

  isCreate: boolean = false
  previousDefault: SiteReferralItem|null = null
  deleteRight = false
  updateRight = false
  settingForm: FormGroup

  constructor(private settingsService: SettingsService) {}

  async ngOnInit(): Promise<void> {

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false
 
    this.isCreate = !this.data.data
    if (this.isCreate) {
      this.settingForm = this.formBuilder.group({
        title: [, Validators.required],
        siteReferralURL: [, Validators.required, checkURLValid],
        useAsDefault: [(this.data.existingValues.length == 0)]
      })
    } else {
      this.initialitzeWithData()
    }
    // if existingValues is Empty default true and disabled...
    if (this.data.existingValues.length == 0 || (!this.isCreate && this.data.existingValues.length == 1)) {
      this.settingForm.controls.useAsDefault.disable()
    } else {
      this.previousDefault = this.data.existingValues?.find(el => el.useAsDefault)
    }
    // subscribe to valuechanges of useAsDefault... 
    this.settingForm.controls.useAsDefault.valueChanges.subscribe((bol) => {
      // when toggeling iterate through the other values and change to false / true
      this.previousDefault.useAsDefault = !bol
    })
  }

  initialitzeWithData() {
    const d = this.data.data
    this.settingForm = this.formBuilder.group({
      title: [d.title, Validators.required],
      siteReferralURL: [d.siteReferralURL, Validators.required, checkURLValid],
      useAsDefault: [d.useAsDefault]
    })
  }

  onSubmit() {
    this.settingForm.controls.useAsDefault.enable();
    const { title, siteReferralURL, useAsDefault } = this.settingForm.value
    if (this.isCreate) {
      const setting: SiteReferralItem = {
        identifier: title,
        title, siteReferralURL, useAsDefault
      }
      const cleaned = removeUndefined(setting)
      this.data.onCreate(cleaned)
    } else {
      const setting = {title, siteReferralURL, useAsDefault}
      Object.assign(this.data.data, setting)
      this.data.onSubmit()
    }
  }

  onDelete(){
    this.data.onDelete(this.data)
  }
}
